import { Flex, Input, Table, Typography } from "antd";
import { SortOrder } from "antd/es/table/interface";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGetAllUsers } from "../../api/api.get";
import { AdminIUser } from "../../types/types";

export default function AdminUsersPage() {
  const { data: users } = useGetAllUsers();
  const [dataSource, setDataSource] = useState<any[]>([]);

  useEffect(() => {
    if (users) {
      const data = users.map((user) => ({
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        countryCode: user.countryCode,
        status: user.status,
        created_at: user.created_at,
        source: user.source,
        username: user.username,
      }));
      setDataSource(data);
    }
  }, [users]);

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      key: "email",
      render: (item: AdminIUser) => {
        return <Link to={`/admin/users/${item.username}`}>{item.email}</Link>;
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Country Code",
      dataIndex: "countryCode",
      key: "countryCode",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text: string) => {
        return moment(text).format("YYYY-MM-DD hh:mm A");
      },
      sorter: (a: any, b: any) =>
        moment(a.created_at).isAfter(moment(b.created_at)) ? 1 : -1,
      sortDirections: ["descend" as SortOrder],
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ];

  return (
    <div className="body">
      <div className="my-20">
        <div className="flex justify-between px-6 py-4 w-full bg-gray-100 mb-10">
          <Link
            to="/home"
            className="flex items-center gap-2 hover:opacity-80 transition"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
            <span className="text-black font-bold">Back</span>
          </Link>
        </div>

        <div className="p-4">
          <Flex>
            <Typography.Title level={2}>Users</Typography.Title>

            <Input
              placeholder="Search by email"
              style={{ width: 300, marginLeft: "auto" }}
              onChange={(e) => {
                const value = e.target.value.toLowerCase();
                const filteredData =
                  users?.filter((user) =>
                    user.email.toLowerCase().includes(value)
                  ) || [];
                const data = filteredData.map((user) => ({
                  firstName: user.firstName,
                  lastName: user.lastName,
                  email: user.email,
                  phone: user.phone,
                  countryCode: user.countryCode,
                  status: user.status,
                  created_at: user.created_at,
                  source: user.source,
                  username: user.username,
                }));
                setDataSource(data);
              }}
            />
          </Flex>
          <Table dataSource={dataSource} columns={columns} />;
        </div>
      </div>
    </div>
  );
}
